import { Stack, Text } from "@certn/cascadia";
import { Card } from "@certn/cascadia-react";
import { Trans } from "react-i18next";
import { css } from "@emotion/css";
import { formatContrastRatio, getContrastRatio } from "./utils";
import { getTextColorForBackground } from "@certn/cascadia-react/utils/colorValidation";
interface ColorSummaryCardProps {
  primaryColor: string;
}

export function ColorSummaryCard({ primaryColor }: ColorSummaryCardProps) {
  return (
    <Card className={styles.container}>
      <Stack orientation="horizontal" justify="space-between">
        <Stack gap="space-0">
          <Text style="summary/content-secondary">
            <Trans>Brand color</Trans>
          </Text>
          <Stack orientation="horizontal" gap="space-2">
            <div
              className={styles.textColorSwatch}
              style={{
                backgroundColor: primaryColor,
              }}
            />
            <Text style="summary/content-primary">{primaryColor}</Text>
          </Stack>
        </Stack>
        <Stack gap="space-0">
          <Text style="summary/content-secondary">
            <Trans>Text color</Trans>
          </Text>
          <Stack orientation="horizontal" gap="space-2">
            <div
              className={styles.textColorSwatch}
              style={{
                backgroundColor: getTextColorForBackground(primaryColor),
              }}
            />
            <Text style="summary/content-primary">
              {getTextColorForBackground(primaryColor)}
            </Text>
          </Stack>
        </Stack>
        <Stack gap="space-0">
          <Text style="summary/content-secondary">
            <Trans>Contrast ratio</Trans>
          </Text>
          <Text style="summary/content-primary">
            {formatContrastRatio(getContrastRatio(primaryColor))}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
}

const styles = {
  container: css({
    paddingTop: "var(--space-4)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
  }),
  textColorSwatch: css({
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: "1px solid var(--border-base)",
    flexShrink: 0,
  }),
};
